import { useDemoStore } from "@/pinia/index.js";
export const version = '3.3'
export function IsRefresh() {
    const localVersion = localStorage.getItem('version')
    if (localVersion) {
        if (localVersion != version) {
            localStorage.setItem('version', version)
            window.location.reload()
        }
    } else {
        localStorage.setItem('version', version)
        window.location.reload()
    }
}
/**
 * @description 格式化时间
 * @param time
 * @param cFormat
 * @returns {string|null}
 */
export function parseTime(time, cFormat) {
    if (arguments.length === 0) {
        return null
    }
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
        date = time
    } else {
        if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
            time = parseInt(time)
        }
        if (typeof time === 'number' && time.toString().length === 10) {
            time = time * 1000
        }
        date = new Date(time)
    }
    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay(),
    }
    return format.replace(/{([ymdhisa])+}/g, (result, key) => {
        let value = formatObj[key]
        if (key === 'a') {
            return ['日', '一', '二', '三', '四', '五', '六'][value]
        }
        if (result.length > 0 && value < 10) {
            value = '0' + value
        }
        return value || 0
    })
}
/**
 * @description 深浅拷贝
 * @param origin 对象
 * @param deep   true深拷贝 false 浅拷贝
 * @returns {*}
 */
export function extend(origin, deep) {
    // deep true  启动深拷贝
    // false  浅拷贝
    let obj = {}
    // 数组对象
    if (origin instanceof Array) {
        // true 数组  obj 就得是数组
        obj = []
    }
    for (let key in origin) {
        let value = origin[key]
        // 确定value是不是引用型，前提是deep 是true
        obj[key] = !!deep && typeof value === 'object' && value !== null ?
            extend(value, deep) :
            value
    }
    return obj
}
/**
 * @description 表情转换为字符
 * @param {*} str 表情
 * @returns 
 */
export function utf16toEntities(str) {
    var patt = /[\ud800-\udbff][\udc00-\udfff]/g; // 检测utf16字符正则 
    str = str.replace(patt, function (char) {
        var H, L, code;
        if (char.length === 2) {
            H = char.charCodeAt(0); // 取出高位 
            L = char.charCodeAt(1); // 取出低位 
            code = (H - 0xD800) * 0x400 + 0x10000 + L - 0xDC00; // 转换算法 
            return "&#" + code + ";";
        } else {
            return char;
        }
    });
    return str;
}
/**
 * @description 字符转换为表情
 * @param {*} str 字符
 * @returns 
 */
export function uncodeUtf16(str) {
    var reg = /\&#.*?;/g;
    var result = str.replace(reg, function (char) {
        var H, L, code;
        if (char.length == 9) {
            code = parseInt(char.match(/[0-9]+/g));
            H = Math.floor((code - 0x10000) / 0x400) + 0xD800;
            L = (code - 0x10000) % 0x400 + 0xDC00;
            return unescape("%u" + H.toString(16) + "%u" + L.toString(16));
        } else {
            return char;
        }
    });
    return result;
}

/**
 * @description 防抖函数
 * @param fn 事件
 * @param delay 时间
 * @returns {*}
 */
export function debounce(fn, delay, leading = false) {
    var timer = null
    return function () {
        if (timer) clearTimeout(timer)
        let _this = this
        var _arguments = arguments
        if (leading) {
            // 通过一个变量来记录是否立即执行
            var isInvoke = false;
            if (!timer) {
                fn.apply(_this, _arguments);
                isInvoke = true;
            }
            // 定时器通过修改timer来修改instant
            timer = setTimeout(function () {
                timer = null;
                if (!isInvoke) {
                    fn.apply(_this, _arguments);
                }
            }, delay);
        } else {
            timer = setTimeout(() => {
                fn.apply(_this, _arguments)
            }, delay)
        }

    }
}
/**
 * @description 节流函数
 * @param fn 事件
 * @param delay 时间
 * @returns {*}
 */
export function throttle(fn, delay) {
    let flag = true
    return function () {
        let th = this
        let args = arguments
        if (!flag) {
            //未超过时间间隔，flag无效，不执行fn
            return false
        }
        fn.apply(th, args)
        flag = false //在时间间隔内把状态位flag设为无效（false）
        setTimeout(() => {
            flag = true //超过时间间隔把状态位flag设为有效（true）
        }, delay)
    }
}

export function getRealJsonData(baseStr) {
    if (!baseStr || typeof baseStr != 'string') return;
    var jsonData = null;
    try {
        jsonData = JSON.parse(baseStr);
    } catch (err) {
        return null;
    }
    var needReplaceStrs = [];
    loopFindArrOrObj(jsonData, needReplaceStrs);
    needReplaceStrs.forEach(function (replaceInfo) {
        var matchArr = baseStr.match(eval('/"' + replaceInfo.key + '":[0-9]{15,}/'));
        if (matchArr) {
            var str = matchArr[0];
            var replaceStr = str.replace('"' + replaceInfo.key + '":', '"' + replaceInfo.key + '":"');
            replaceStr += '"';
            baseStr = baseStr.replace(str, replaceStr);
        }
    });
    var returnJson = null;
    try {
        returnJson = JSON.parse(baseStr);
    } catch (err) {
        return null;
    }
    return returnJson;
}

//遍历对象类型的
function getNeedRpStrByObj(obj, needReplaceStrs) {
    for (var key in obj) {
        var value = obj[key];
        if (typeof value == 'number' && value > 9007199254740992) {
            needReplaceStrs.push({ key: key });
        }
        loopFindArrOrObj(value, needReplaceStrs);
    }
}

//遍历数组类型的
function getNeedRpStrByArr(arr, needReplaceStrs) {
    for (var i = 0; i < arr.length; i++) {
        var value = arr[i];
        loopFindArrOrObj(value, needReplaceStrs);
    }
}

//递归遍历
function loopFindArrOrObj(value, needRpStrArr) {
    var valueTypeof = Object.prototype.toString.call(value);
    if (valueTypeof == '[object Object]') {
        needRpStrArr.concat(getNeedRpStrByObj(value, needRpStrArr));
    }
    if (valueTypeof == '[object Array]') {
        needRpStrArr.concat(getNeedRpStrByArr(value, needRpStrArr));
    }
}

/**
 * @description 获取更新时间
 * @param fn 事件
 * @param delay 时间
 * @returns {*}
 */
export function getupdate_time(time) {
    let nowTime = new Date().getTime()
    let upTime = new Date(parseTime(time)).getTime()
    if ((nowTime - upTime) / 1000 / 60 / 60 < 24) {
        if (useDemoStore().lang == "en-us") {
            if (new Date(parseTime(time)).getHours() <= 12) {
                let h = new Date(parseTime(time)).getHours()
                h = h >= 10 ? h : '0' + h
                let m = new Date(parseTime(time)).getMinutes()
                m = m >= 10 ? m : '0' + m
                return h + ":" + m + ' AM'
            } else {
                let h = new Date(parseTime(time)).getHours() - 12
                h = h >= 10 ? h : '0' + h
                let m = new Date(parseTime(time)).getMinutes()
                m = m >= 10 ? m : '0' + m
                return h + ":" + m + ' PM'
            }
        }
        else {
            if (new Date(parseTime(time)).getHours() < 12) {
                let h = new Date(parseTime(time)).getHours()
                h = h >= 10 ? h : '0' + h
                let m = new Date(parseTime(time)).getMinutes()
                m = m >= 10 ? m : '0' + m
                return '上午 ' + h + ":" + m
            } else {
                let h = new Date(parseTime(time)).getHours() - 12
                h = h >= 10 ? h : '0' + h
                let m = new Date(parseTime(time)).getMinutes()
                m = m >= 10 ? m : '0' + m
                return '下午 ' + h + ":" + m
            }
        }
    }
    else {
        if (useDemoStore().lang == "en-us") {
            return parseTime(time, "{m}.{d}.{y} {h}:{m}");
        }
        else {
            return parseTime(time, "{y}.{m}.{d} {h}:{i}");
        }
    }
}

/**
 * @description 获取更新时间
 * @param fn 事件
 * @param delay 时间
 * @returns {*}
 */
export function getupdate_time1(time) {
    let nowTime = new Date().getTime()
    let upTime = new Date(parseTime(time)).getTime()
    if ((nowTime - upTime) / 1000 / 60 / 60 < 1) {
        if (useDemoStore().lang == "en-us") {
            let m = parseInt((nowTime - upTime) / 1000 / 60)
            if (m) {
                return parseInt((nowTime - upTime) / 1000 / 60) + ' minutes ago'
            } else {
                return 'just'
            }

        }
        else {
            let m = parseInt((nowTime - upTime) / 1000 / 60)
            if (m) {
                return parseInt((nowTime - upTime) / 1000 / 60) + ' 分钟前'
            } else {
                return '刚刚'
            }

        }
    }
    else if ((nowTime - upTime) / 1000 / 60 / 60 < 24) {
        if (useDemoStore().lang == "en-us") {
            return parseInt((nowTime - upTime) / 1000 / 60 / 60) + ' hours ago'
        }
        else {
            return parseInt((nowTime - upTime) / 1000 / 60 / 60) + ' 小时前'
        }
    }
    else {
        if (useDemoStore().lang == "en-us") {
            return parseTime(time, "{m}.{d}.{y} {h}:{m}");
        }
        else {
            return parseTime(time, "{y}.{m}.{d} {h}:{i}");
        }
    }
}
// 转换时间
export function getTime(time, val) {
    if (useDemoStore().lang == "en-us") {
        return parseTime(time, `{m}${val}{d}${val}{y} {h}:{i}`)
    }
    else {
        return parseTime(time, `{y}${val}{m}${val}{d} {h}:{i}`)
    }
}

//获取前端定义的用户类型
export function getWebType(val) {
    // ['type' => '1','oldType' => [5],'typeName' => '超级管理员'],
    // ['type' => '2','oldType' => [3,6],'typeName' => '销售'],
    // ['type' => '3','oldType' => [4,9],'typeName' => '采购'],
    // //['type' => '4','oldType' => [19],'typeName' => '客户'],
    // ['type' => '5','oldType' => [8],'typeName' => '财务'],
    // ['type' => '6','oldType' => [1],'typeName' => '管理员'],
    if (val == 5) {
        return 1
    }
    else if (val == 3 || val == 6) {
        return 2
    }
    else if (val == 4 || val == 9) {
        return 3
    }
    else if (val == 19) {
        return 4
    }
    else if (val == 8) {
        return 5
    }
    else if (val == 1) {
        return 6
    }
    else {
        return val
    }
}
/**
 * 货币转换
 * @param  { String } current - 货币类型
 * @returns 返回货币符号
 */
export const currencType = (current) => {
    let currencySymbol = ''
    if (current == 'USD') {
        currencySymbol = '$';
    } else if (current == 'CNY') {
        currencySymbol = '￥';
    } else if (current == 'EUR') {
        currencySymbol = '€';
    } else if (current == 'GBP') {
        currencySymbol = '￡';
    } else if (current == 'CAD') {
        currencySymbol = 'CA$';
    } else if (current == 'AUD') {
        currencySymbol = 'AU$';
    } else if (current == 'HKD') {
        currencySymbol = 'HK$';
    } else if (current == 'RUB') {
        currencySymbol = '₽'
    } else if (current == 'KRW') {
        currencySymbol = '₩'
    } else if (current == 'JPY') {
        currencySymbol = '¥'
    } else if (current == 'INR') {
        currencySymbol = '₹'
    } else if (current == 'SGD') {
        currencySymbol = 'S$'
    } else if (current == 'IDR') {
        currencySymbol = 'Rp'
    } else if (current == 'THB') {
        currencySymbol = '฿'
    } else if (current == 'DKK') {
        currencySymbol = 'Kr'
    } else if (current == 'SAR') {
        currencySymbol = '﷼'
    } else if (current == 'PHP') {
        currencySymbol = '₱'
    } else if (current == 'TWD') {
        currencySymbol = 'NT'
    } else if (current == 'ZAR') {
        currencySymbol = 'R'
    } else if (current == 'AED') {
        currencySymbol = 'د.إ'
    } else if (current == 'BRL') {
        currencySymbol = 'R$'
    } else if (current == 'CHF') {
        currencySymbol = 'Fr'
    } else if (current == 'NOK') {
        currencySymbol = 'NOK'
    } else if (current == 'MOP') {
        currencySymbol = 'MOP'
    } else if (current == 'NZD') {
        currencySymbol = 'NZ$'
    } else if (current == 'TRY') {
        currencySymbol = '₺'
    } else if (current == 'SEK') {
        currencySymbol = 'SEK'
    } else if (current == 'MYR') {
        currencySymbol = 'RM'
    } else if (current == 'USDT') {
        currencySymbol = '₮'
    } else {
        currencySymbol = current
    }
    return currencySymbol
}
export function convertNum(val) {
	if (Number(val) <= 10 && Number(val) > 0) {
		return '0' + val
	}else{
		return val
	}
}